var map = {
	"./": [
		72812,
		9
	],
	"./App": [
		54111,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.js": [
		54111,
		9
	],
	"./Context": [
		41589,
		9
	],
	"./Context.jsx": [
		41589,
		9
	],
	"./assets/piano-music-15-sec.mp3": [
		64390,
		1,
		4390
	],
	"./blogs/biology/AnimalHeart": [
		39986,
		9,
		97,
		9986
	],
	"./blogs/biology/AnimalHeart.js": [
		39986,
		9,
		97,
		9986
	],
	"./blogs/biology/AnimalKingdomFlow": [
		85483,
		9,
		5997,
		5405,
		5483
	],
	"./blogs/biology/AnimalKingdomFlow.js": [
		85483,
		9,
		5997,
		5405,
		5483
	],
	"./blogs/biology/AnimalTissueFlow": [
		42863,
		9,
		5997,
		5405,
		2863
	],
	"./blogs/biology/AnimalTissueFlow.js": [
		42863,
		9,
		5997,
		5405,
		2863
	],
	"./blogs/biology/BiologyMindMap": [
		15231,
		7,
		5231
	],
	"./blogs/biology/BiologyMindMap.js": [
		15231,
		7,
		5231
	],
	"./blogs/biology/BiologyQuesSet": [
		45855,
		9,
		97,
		5855
	],
	"./blogs/biology/BiologyQuesSet.js": [
		45855,
		9,
		97,
		5855
	],
	"./blogs/biology/BloodCirculationSystemTimeline": [
		79245,
		9,
		5997,
		5405,
		9245
	],
	"./blogs/biology/BloodCirculationSystemTimeline.js": [
		79245,
		9,
		5997,
		5405,
		9245
	],
	"./blogs/biology/BrainFlow": [
		67798,
		9,
		5997,
		5405,
		7798
	],
	"./blogs/biology/BrainFlow.js": [
		67798,
		9,
		5997,
		5405,
		7798
	],
	"./blogs/biology/DigestiveSystemTimeline": [
		50834,
		9,
		5997,
		5405,
		834
	],
	"./blogs/biology/DigestiveSystemTimeline.js": [
		50834,
		9,
		5997,
		5405,
		834
	],
	"./blogs/biology/DiseasesStudyGuide": [
		80080,
		9,
		5997,
		5405,
		80
	],
	"./blogs/biology/DiseasesStudyGuide.js": [
		80080,
		9,
		5997,
		5405,
		80
	],
	"./blogs/biology/ExcretorySystemTimeline": [
		97759,
		9,
		5997,
		5405,
		7759
	],
	"./blogs/biology/ExcretorySystemTimeline.js": [
		97759,
		9,
		5997,
		5405,
		7759
	],
	"./blogs/biology/GlandsHormones": [
		29912,
		9,
		5997,
		5405,
		9912
	],
	"./blogs/biology/GlandsHormones.js": [
		29912,
		9,
		5997,
		5405,
		9912
	],
	"./blogs/biology/NutritionAndVitamins": [
		426,
		9,
		5997,
		5405,
		426
	],
	"./blogs/biology/NutritionAndVitamins.js": [
		426,
		9,
		5997,
		5405,
		426
	],
	"./blogs/biology/PlantKingdomFlow": [
		55970,
		9,
		5997,
		5405,
		5970
	],
	"./blogs/biology/PlantKingdomFlow.js": [
		55970,
		9,
		5997,
		5405,
		5970
	],
	"./blogs/biology/PlantTissueFlow": [
		23324,
		9,
		5997,
		5405,
		3324
	],
	"./blogs/biology/PlantTissueFlow.js": [
		23324,
		9,
		5997,
		5405,
		3324
	],
	"./blogs/biology/ReproductionTimeline": [
		2073,
		9,
		5997,
		5405,
		2073
	],
	"./blogs/biology/ReproductionTimeline.js": [
		2073,
		9,
		5997,
		5405,
		2073
	],
	"./blogs/biology/RespiratorySystemTimeline": [
		21244,
		9,
		5997,
		5405,
		1244
	],
	"./blogs/biology/RespiratorySystemTimeline.js": [
		21244,
		9,
		5997,
		5405,
		1244
	],
	"./blogs/biology/TheCellFlow": [
		89921,
		9,
		5997,
		5405,
		9921
	],
	"./blogs/biology/TheCellFlow.js": [
		89921,
		9,
		5997,
		5405,
		9921
	],
	"./blogs/computer/Computer-RRB-50": [
		19686,
		9,
		5997,
		5405,
		9686
	],
	"./blogs/computer/Computer-RRB-50.js": [
		19686,
		9,
		5997,
		5405,
		9686
	],
	"./blogs/computer/Computer-fullform": [
		7109,
		9,
		5997,
		5405,
		7109
	],
	"./blogs/computer/Computer-fullform.js": [
		7109,
		9,
		5997,
		5405,
		7109
	],
	"./blogs/computer/Internet-basics": [
		49505,
		9,
		5997,
		5405,
		9505
	],
	"./blogs/computer/Internet-basics.js": [
		49505,
		9,
		5997,
		5405,
		9505
	],
	"./blogs/computer/Introduction-Computer": [
		29008,
		9,
		5997,
		5405,
		9008
	],
	"./blogs/computer/Introduction-Computer.js": [
		29008,
		9,
		5997,
		5405,
		9008
	],
	"./blogs/current/AppsPortals": [
		3455,
		9,
		5997,
		5405,
		3455
	],
	"./blogs/current/AppsPortals.js": [
		3455,
		9,
		5997,
		5405,
		3455
	],
	"./blogs/current/AsianGames2023": [
		2336,
		9,
		5997,
		5405,
		2336
	],
	"./blogs/current/AsianGames2023.js": [
		2336,
		9,
		5997,
		5405,
		2336
	],
	"./blogs/current/BooksAuthorsLiteraryAwards": [
		14578,
		9,
		5997,
		5405,
		4578
	],
	"./blogs/current/BooksAuthorsLiteraryAwards.js": [
		14578,
		9,
		5997,
		5405,
		4578
	],
	"./blogs/current/CabinetMinister25": [
		87642,
		9,
		5997,
		5405,
		7642
	],
	"./blogs/current/CabinetMinister25.js": [
		87642,
		9,
		5997,
		5405,
		7642
	],
	"./blogs/current/CricketUpdates25": [
		73560,
		9,
		5997,
		5405,
		3560
	],
	"./blogs/current/CricketUpdates25.js": [
		73560,
		9,
		5997,
		5405,
		3560
	],
	"./blogs/current/CurrentAffairsEconomy": [
		64695,
		9,
		5997,
		5405,
		4695
	],
	"./blogs/current/CurrentAffairsEconomy.js": [
		64695,
		9,
		5997,
		5405,
		4695
	],
	"./blogs/current/DefenceRRB2026": [
		33342,
		9,
		5997,
		5405,
		3342
	],
	"./blogs/current/DefenceRRB2026.js": [
		33342,
		9,
		5997,
		5405,
		3342
	],
	"./blogs/current/DefenceSecurity": [
		17110,
		9,
		5997,
		5405,
		7110
	],
	"./blogs/current/DefenceSecurity.js": [
		17110,
		9,
		5997,
		5405,
		7110
	],
	"./blogs/current/DelhiPoliceRevision2025": [
		10770,
		9,
		5997,
		5405,
		770
	],
	"./blogs/current/DelhiPoliceRevision2025.js": [
		10770,
		9,
		5997,
		5405,
		770
	],
	"./blogs/current/DigitalAIAndHealthInnovation": [
		34216,
		9,
		5997,
		5405,
		1835
	],
	"./blogs/current/DigitalAIAndHealthInnovation.js": [
		34216,
		9,
		5997,
		5405,
		1835
	],
	"./blogs/current/EnvironmentEcology": [
		61909,
		9,
		5997,
		5405,
		1909
	],
	"./blogs/current/EnvironmentEcology.js": [
		61909,
		9,
		5997,
		5405,
		1909
	],
	"./blogs/current/EventsJan2026": [
		93744,
		9,
		5997,
		5405,
		3744
	],
	"./blogs/current/EventsJan2026.js": [
		93744,
		9,
		5997,
		5405,
		3744
	],
	"./blogs/current/FirstIndiaWorld": [
		31043,
		9,
		5997,
		5405,
		1043
	],
	"./blogs/current/FirstIndiaWorld.js": [
		31043,
		9,
		5997,
		5405,
		1043
	],
	"./blogs/current/GovernmentInitiatives": [
		24418,
		9,
		5997,
		5405,
		4418
	],
	"./blogs/current/GovernmentInitiatives.js": [
		24418,
		9,
		5997,
		5405,
		4418
	],
	"./blogs/current/GovtInitiative2025": [
		40123,
		9,
		5997,
		5405,
		123
	],
	"./blogs/current/GovtInitiative2025.js": [
		40123,
		9,
		5997,
		5405,
		123
	],
	"./blogs/current/IITInnovations": [
		97260,
		9,
		5997,
		5405,
		7260
	],
	"./blogs/current/IITInnovations.js": [
		97260,
		9,
		5997,
		5405,
		7260
	],
	"./blogs/current/ImpOperations": [
		34432,
		9,
		5997,
		5405,
		4432
	],
	"./blogs/current/ImpOperations.js": [
		34432,
		9,
		5997,
		5405,
		4432
	],
	"./blogs/current/Index&Ranking2026": [
		61366,
		9,
		5997,
		5405,
		1366
	],
	"./blogs/current/Index&Ranking2026.js": [
		61366,
		9,
		5997,
		5405,
		1366
	],
	"./blogs/current/InternationalCurrentAffairs2025": [
		89686,
		9,
		5997,
		5405,
		7305
	],
	"./blogs/current/InternationalCurrentAffairs2025.js": [
		89686,
		9,
		5997,
		5405,
		7305
	],
	"./blogs/current/InternationalSummits": [
		44230,
		9,
		5997,
		5405,
		4230
	],
	"./blogs/current/InternationalSummits.js": [
		44230,
		9,
		5997,
		5405,
		4230
	],
	"./blogs/current/January2026": [
		45696,
		9,
		5997,
		5405,
		5696
	],
	"./blogs/current/January2026.js": [
		45696,
		9,
		5997,
		5405,
		5696
	],
	"./blogs/current/KheloWinterGames2025": [
		65732,
		9,
		5997,
		5405,
		5732
	],
	"./blogs/current/KheloWinterGames2025.js": [
		65732,
		9,
		5997,
		5405,
		5732
	],
	"./blogs/current/MajorReportsIndia": [
		40191,
		9,
		5997,
		5405,
		191
	],
	"./blogs/current/MajorReportsIndia.js": [
		40191,
		9,
		5997,
		5405,
		191
	],
	"./blogs/current/MixedSports25": [
		81981,
		9,
		5997,
		5405,
		1981
	],
	"./blogs/current/MixedSports25.js": [
		81981,
		9,
		5997,
		5405,
		1981
	],
	"./blogs/current/ModiAwards": [
		80895,
		9,
		5997,
		5405,
		895
	],
	"./blogs/current/ModiAwards.js": [
		80895,
		9,
		5997,
		5405,
		895
	],
	"./blogs/current/NationalCurrentAffairs3026": [
		99742,
		9,
		5997,
		5405,
		9742
	],
	"./blogs/current/NationalCurrentAffairs3026.js": [
		99742,
		9,
		5997,
		5405,
		9742
	],
	"./blogs/current/NationalGames2025": [
		59146,
		9,
		5997,
		5405,
		9146
	],
	"./blogs/current/NationalGames2025.js": [
		59146,
		9,
		5997,
		5405,
		9146
	],
	"./blogs/current/NobelPrize2025": [
		83035,
		9,
		5997,
		5405,
		3035
	],
	"./blogs/current/NobelPrize2025.js": [
		83035,
		9,
		5997,
		5405,
		3035
	],
	"./blogs/current/ParisOlympic2024": [
		4472,
		9,
		5997,
		5405,
		4472
	],
	"./blogs/current/ParisOlympic2024.js": [
		4472,
		9,
		5997,
		5405,
		4472
	],
	"./blogs/current/ParisParalympics2024": [
		26894,
		9,
		5997,
		5405,
		6894
	],
	"./blogs/current/ParisParalympics2024.js": [
		26894,
		9,
		5997,
		5405,
		6894
	],
	"./blogs/current/RecordsRankings2526": [
		34612,
		9,
		5997,
		5405,
		4612
	],
	"./blogs/current/RecordsRankings2526.js": [
		34612,
		9,
		5997,
		5405,
		4612
	],
	"./blogs/current/ScienceTechUpdates": [
		28658,
		9,
		5997,
		5405,
		8658
	],
	"./blogs/current/ScienceTechUpdates.js": [
		28658,
		9,
		5997,
		5405,
		8658
	],
	"./blogs/current/SpaceAndDefenceTech": [
		77961,
		9,
		5997,
		5405,
		7961
	],
	"./blogs/current/SpaceAndDefenceTech.js": [
		77961,
		9,
		5997,
		5405,
		7961
	],
	"./blogs/current/SpaceTechnology": [
		62900,
		9,
		5997,
		5405,
		2900
	],
	"./blogs/current/SpaceTechnology.js": [
		62900,
		9,
		5997,
		5405,
		2900
	],
	"./blogs/current/SportsUpdates2024_25": [
		14251,
		9,
		5997,
		5405,
		4251
	],
	"./blogs/current/SportsUpdates2024_25.js": [
		14251,
		9,
		5997,
		5405,
		4251
	],
	"./blogs/current/StatuesImp": [
		95519,
		9,
		5997,
		5405,
		5519
	],
	"./blogs/current/StatuesImp.js": [
		95519,
		9,
		5997,
		5405,
		5519
	],
	"./blogs/current/TennisUpdates25": [
		522,
		9,
		5997,
		5405,
		522
	],
	"./blogs/current/TennisUpdates25.js": [
		522,
		9,
		5997,
		5405,
		522
	],
	"./blogs/current/WorldParaAthleticsChampionships25": [
		95710,
		9,
		5997,
		5405,
		5710
	],
	"./blogs/current/WorldParaAthleticsChampionships25.js": [
		95710,
		9,
		5997,
		5405,
		5710
	],
	"./blogs/economy/BankingInsurance": [
		32267,
		9,
		5997,
		5405,
		2267
	],
	"./blogs/economy/BankingInsurance.js": [
		32267,
		9,
		5997,
		5405,
		2267
	],
	"./blogs/economy/BudgetManage": [
		47071,
		9,
		5997,
		5405,
		7071
	],
	"./blogs/economy/BudgetManage.js": [
		47071,
		9,
		5997,
		5405,
		7071
	],
	"./blogs/economy/EconomicsBasics": [
		71252,
		9,
		5997,
		5405,
		1252
	],
	"./blogs/economy/EconomicsBasics.js": [
		71252,
		9,
		5997,
		5405,
		1252
	],
	"./blogs/economy/EconomyMindMap": [
		28751,
		9,
		8751
	],
	"./blogs/economy/EconomyMindMap.js": [
		28751,
		9,
		8751
	],
	"./blogs/economy/FiscalPolicy": [
		44369,
		9,
		5997,
		5405,
		4369
	],
	"./blogs/economy/FiscalPolicy.js": [
		44369,
		9,
		5997,
		5405,
		4369
	],
	"./blogs/economy/FiveYearPlans": [
		34726,
		9,
		5997,
		5405,
		4726
	],
	"./blogs/economy/FiveYearPlans.js": [
		34726,
		9,
		5997,
		5405,
		4726
	],
	"./blogs/economy/GoodsTerms": [
		96004,
		9,
		5997,
		5405,
		6004
	],
	"./blogs/economy/GoodsTerms.js": [
		96004,
		9,
		5997,
		5405,
		6004
	],
	"./blogs/economy/NationalIncome": [
		56136,
		9,
		5997,
		5405,
		6136
	],
	"./blogs/economy/NationalIncome.js": [
		56136,
		9,
		5997,
		5405,
		6136
	],
	"./blogs/geography/AtmosphereFlow": [
		87455,
		9,
		5997,
		5405,
		7455
	],
	"./blogs/geography/AtmosphereFlow.js": [
		87455,
		9,
		5997,
		5405,
		7455
	],
	"./blogs/geography/ConservationSitesFlow": [
		85864,
		9,
		5997,
		5405,
		5864
	],
	"./blogs/geography/ConservationSitesFlow.js": [
		85864,
		9,
		5997,
		5405,
		5864
	],
	"./blogs/geography/DamsLakesFlow": [
		18862,
		9,
		5997,
		5405,
		8862
	],
	"./blogs/geography/DamsLakesFlow.js": [
		18862,
		9,
		5997,
		5405,
		8862
	],
	"./blogs/geography/DrainageFlow": [
		17558,
		9,
		5997,
		5405,
		7558
	],
	"./blogs/geography/DrainageFlow.js": [
		17558,
		9,
		5997,
		5405,
		7558
	],
	"./blogs/geography/EarthInteriorTectonic": [
		73354,
		9,
		5997,
		5405,
		3354
	],
	"./blogs/geography/EarthInteriorTectonic.js": [
		73354,
		9,
		5997,
		5405,
		3354
	],
	"./blogs/geography/Forest&GrassFlow": [
		74878,
		9,
		5997,
		5405,
		4878
	],
	"./blogs/geography/Forest&GrassFlow.js": [
		74878,
		9,
		5997,
		5405,
		4878
	],
	"./blogs/geography/GeomorphologyFlow": [
		25224,
		9,
		5997,
		5405,
		5224
	],
	"./blogs/geography/GeomorphologyFlow.js": [
		25224,
		9,
		5997,
		5405,
		5224
	],
	"./blogs/geography/HimalayaFlow": [
		90511,
		9,
		5997,
		5405,
		511
	],
	"./blogs/geography/HimalayaFlow.js": [
		90511,
		9,
		5997,
		5405,
		511
	],
	"./blogs/geography/IndiaBoundaryFlow": [
		93902,
		9,
		5997,
		5405,
		3902
	],
	"./blogs/geography/IndiaBoundaryFlow.js": [
		93902,
		9,
		5997,
		5405,
		3902
	],
	"./blogs/geography/IndianSoilFlow": [
		38347,
		9,
		5997,
		5405,
		8347
	],
	"./blogs/geography/IndianSoilFlow.js": [
		38347,
		9,
		5997,
		5405,
		8347
	],
	"./blogs/geography/Longitude&Latitude": [
		82738,
		9,
		5997,
		5405,
		2738
	],
	"./blogs/geography/Longitude&Latitude.js": [
		82738,
		9,
		5997,
		5405,
		2738
	],
	"./blogs/geography/MineralsFlow": [
		79928,
		9,
		5997,
		5405,
		9928
	],
	"./blogs/geography/MineralsFlow.js": [
		79928,
		9,
		5997,
		5405,
		9928
	],
	"./blogs/geography/MineralsOfIndia": [
		23350,
		9,
		97,
		3350
	],
	"./blogs/geography/MineralsOfIndia.js": [
		23350,
		9,
		97,
		3350
	],
	"./blogs/geography/MonsoonFlow": [
		95502,
		9,
		5997,
		5405,
		3121
	],
	"./blogs/geography/MonsoonFlow.js": [
		95502,
		9,
		5997,
		5405,
		3121
	],
	"./blogs/geography/NorthPlains": [
		81629,
		9,
		5997,
		5405,
		1629
	],
	"./blogs/geography/NorthPlains.js": [
		81629,
		9,
		5997,
		5405,
		1629
	],
	"./blogs/geography/PeninsularPlateauFlow": [
		21404,
		9,
		5997,
		5405,
		1404
	],
	"./blogs/geography/PeninsularPlateauFlow.js": [
		21404,
		9,
		5997,
		5405,
		1404
	],
	"./blogs/geography/PeninsularRiversFlow": [
		39803,
		9,
		5997,
		5405,
		9803
	],
	"./blogs/geography/PeninsularRiversFlow.js": [
		39803,
		9,
		5997,
		5405,
		9803
	],
	"./blogs/geography/RiverTributaries": [
		219,
		9,
		5997,
		5405,
		219
	],
	"./blogs/geography/RiverTributaries.js": [
		219,
		9,
		5997,
		5405,
		219
	],
	"./blogs/geography/RocksFlow": [
		15621,
		9,
		5997,
		5405,
		5621
	],
	"./blogs/geography/RocksFlow.js": [
		15621,
		9,
		5997,
		5405,
		5621
	],
	"./blogs/geography/SolarSystemFlow": [
		51735,
		9,
		5997,
		5405,
		1735
	],
	"./blogs/geography/SolarSystemFlow.js": [
		51735,
		9,
		5997,
		5405,
		1735
	],
	"./blogs/geography/WindClimateOcean": [
		9850,
		9,
		5997,
		5405,
		9850
	],
	"./blogs/geography/WindClimateOcean.js": [
		9850,
		9,
		5997,
		5405,
		9850
	],
	"./blogs/geography/WorldFlow": [
		99459,
		9,
		5997,
		5405,
		9459
	],
	"./blogs/geography/WorldFlow.js": [
		99459,
		9,
		5997,
		5405,
		9459
	],
	"./blogs/history/1857RevoltFlow": [
		12382,
		9,
		5997,
		5405,
		2382
	],
	"./blogs/history/1857RevoltFlow.js": [
		12382,
		9,
		5997,
		5405,
		2382
	],
	"./blogs/history/AdminPosition": [
		11441,
		9,
		5997,
		5405,
		1441
	],
	"./blogs/history/AdminPosition.js": [
		11441,
		9,
		5997,
		5405,
		1441
	],
	"./blogs/history/BengalPartitionFlow": [
		85190,
		9,
		5997,
		5405,
		5190
	],
	"./blogs/history/BengalPartitionFlow.js": [
		85190,
		9,
		5997,
		5405,
		5190
	],
	"./blogs/history/Bhakti-Movement-Flowchart": [
		79697,
		9,
		5997,
		5405,
		9697
	],
	"./blogs/history/Bhakti-Movement-Flowchart.js": [
		79697,
		9,
		5997,
		5405,
		9697
	],
	"./blogs/history/Buddhism-History": [
		16178,
		9,
		5997,
		5405,
		6178
	],
	"./blogs/history/Buddhism-History.js": [
		16178,
		9,
		5997,
		5405,
		6178
	],
	"./blogs/history/EuropeanAdventFlow": [
		77150,
		9,
		5997,
		5405,
		7150
	],
	"./blogs/history/EuropeanAdventFlow.js": [
		77150,
		9,
		5997,
		5405,
		7150
	],
	"./blogs/history/GandhiFlow": [
		70604,
		9,
		5997,
		5405,
		604
	],
	"./blogs/history/GandhiFlow.js": [
		70604,
		9,
		5997,
		5405,
		604
	],
	"./blogs/history/Gupta-Empire": [
		11927,
		9,
		5997,
		5405,
		1927
	],
	"./blogs/history/Gupta-Empire.js": [
		11927,
		9,
		5997,
		5405,
		1927
	],
	"./blogs/history/History25Steno1": [
		65820,
		9,
		5997,
		5405,
		5820
	],
	"./blogs/history/History25Steno1.js": [
		65820,
		9,
		5997,
		5405,
		5820
	],
	"./blogs/history/HistoryMindMap": [
		40575,
		7,
		575
	],
	"./blogs/history/HistoryMindMap.js": [
		40575,
		7,
		575
	],
	"./blogs/history/ImportantActsFlow": [
		99918,
		9,
		5997,
		5405,
		9918
	],
	"./blogs/history/ImportantActsFlow.js": [
		99918,
		9,
		5997,
		5405,
		9918
	],
	"./blogs/history/ImportantBattles": [
		43920,
		9,
		5997,
		5405,
		3920
	],
	"./blogs/history/ImportantBattles.js": [
		43920,
		9,
		5997,
		5405,
		3920
	],
	"./blogs/history/IndianCongress": [
		87684,
		9,
		5997,
		5405,
		7684
	],
	"./blogs/history/IndianCongress.js": [
		87684,
		9,
		5997,
		5405,
		7684
	],
	"./blogs/history/Indus-Valley-Civilisation": [
		73031,
		9,
		5997,
		5405,
		3031
	],
	"./blogs/history/Indus-Valley-Civilisation.js": [
		73031,
		9,
		5997,
		5405,
		3031
	],
	"./blogs/history/Islamic-Invasion-Delhi-Sultanate": [
		86920,
		9,
		5997,
		5405,
		6920
	],
	"./blogs/history/Islamic-Invasion-Delhi-Sultanate.js": [
		86920,
		9,
		5997,
		5405,
		6920
	],
	"./blogs/history/Jainism-History": [
		46577,
		9,
		5997,
		5405,
		6577
	],
	"./blogs/history/Jainism-History.js": [
		46577,
		9,
		5997,
		5405,
		6577
	],
	"./blogs/history/Mahajanapadas-Flowchart": [
		7382,
		9,
		5997,
		5405,
		7382
	],
	"./blogs/history/Mahajanapadas-Flowchart.js": [
		7382,
		9,
		5997,
		5405,
		7382
	],
	"./blogs/history/Maratha-Empire": [
		9372,
		9,
		5997,
		5405,
		9372
	],
	"./blogs/history/Maratha-Empire.js": [
		9372,
		9,
		5997,
		5405,
		9372
	],
	"./blogs/history/Mauryan-Empire": [
		60383,
		9,
		5997,
		5405,
		383
	],
	"./blogs/history/Mauryan-Empire.js": [
		60383,
		9,
		5997,
		5405,
		383
	],
	"./blogs/history/Modern-History": [
		21383,
		9,
		5997,
		5405,
		1383
	],
	"./blogs/history/Modern-History.js": [
		21383,
		9,
		5997,
		5405,
		1383
	],
	"./blogs/history/Mughal-Empire": [
		7942,
		9,
		5997,
		5405,
		7942
	],
	"./blogs/history/Mughal-Empire.js": [
		7942,
		9,
		5997,
		5405,
		7942
	],
	"./blogs/history/Post-Gupta-Chalukya": [
		37934,
		9,
		5997,
		5405,
		7934
	],
	"./blogs/history/Post-Gupta-Chalukya.js": [
		37934,
		9,
		5997,
		5405,
		7934
	],
	"./blogs/history/Post-Maurya-Empire": [
		11632,
		9,
		5997,
		5405,
		1632
	],
	"./blogs/history/Post-Maurya-Empire.js": [
		11632,
		9,
		5997,
		5405,
		1632
	],
	"./blogs/history/QuitIndiaMovement": [
		41510,
		9,
		5997,
		5405,
		1510
	],
	"./blogs/history/QuitIndiaMovement.js": [
		41510,
		9,
		5997,
		5405,
		1510
	],
	"./blogs/history/ReligiousReforms": [
		74844,
		9,
		5997,
		5405,
		4844
	],
	"./blogs/history/ReligiousReforms.js": [
		74844,
		9,
		5997,
		5405,
		4844
	],
	"./blogs/history/Rulers&Dynasties": [
		8002,
		9,
		5997,
		5405,
		8002
	],
	"./blogs/history/Rulers&Dynasties.js": [
		8002,
		9,
		5997,
		5405,
		8002
	],
	"./blogs/history/Sangam-Age": [
		1406,
		9,
		5997,
		5405,
		1406
	],
	"./blogs/history/Sangam-Age.js": [
		1406,
		9,
		5997,
		5405,
		1406
	],
	"./blogs/history/SocialismFlow": [
		51259,
		9,
		5997,
		5405,
		1259
	],
	"./blogs/history/SocialismFlow.js": [
		51259,
		9,
		5997,
		5405,
		1259
	],
	"./blogs/history/StoneAge": [
		4881,
		9,
		5997,
		5405,
		4881
	],
	"./blogs/history/StoneAge.js": [
		4881,
		9,
		5997,
		5405,
		4881
	],
	"./blogs/history/TaxationSystem": [
		60202,
		9,
		5997,
		5405,
		202
	],
	"./blogs/history/TaxationSystem.js": [
		60202,
		9,
		5997,
		5405,
		202
	],
	"./blogs/history/Travellers": [
		3289,
		9,
		5997,
		5405,
		3289
	],
	"./blogs/history/Travellers.js": [
		3289,
		9,
		5997,
		5405,
		3289
	],
	"./blogs/history/Tripartite-Struggle-Chola": [
		47979,
		9,
		5997,
		5405,
		7979
	],
	"./blogs/history/Tripartite-Struggle-Chola.js": [
		47979,
		9,
		5997,
		5405,
		7979
	],
	"./blogs/history/Vedic-Age": [
		23752,
		9,
		5997,
		5405,
		3752
	],
	"./blogs/history/Vedic-Age.js": [
		23752,
		9,
		5997,
		5405,
		3752
	],
	"./blogs/history/Vijaynagar-Timeline": [
		51645,
		9,
		5997,
		5405,
		1645
	],
	"./blogs/history/Vijaynagar-Timeline.js": [
		51645,
		9,
		5997,
		5405,
		1645
	],
	"./blogs/polity/AmendmentsConstitutional": [
		82246,
		9,
		5997,
		5405,
		2246
	],
	"./blogs/polity/AmendmentsConstitutional.js": [
		82246,
		9,
		5997,
		5405,
		2246
	],
	"./blogs/polity/ConstitutionalBodyFlow": [
		49754,
		9,
		5997,
		5405,
		9754
	],
	"./blogs/polity/ConstitutionalBodyFlow.js": [
		49754,
		9,
		5997,
		5405,
		9754
	],
	"./blogs/polity/ConstitutionalParts": [
		8298,
		9,
		5997,
		5405,
		8298
	],
	"./blogs/polity/ConstitutionalParts.js": [
		8298,
		9,
		5997,
		5405,
		8298
	],
	"./blogs/polity/EmergencyFlow": [
		59915,
		9,
		5997,
		5405,
		9915
	],
	"./blogs/polity/EmergencyFlow.js": [
		59915,
		9,
		5997,
		5405,
		9915
	],
	"./blogs/polity/FeaturesOfConstitution": [
		39001,
		9,
		5997,
		5405,
		9001
	],
	"./blogs/polity/FeaturesOfConstitution.js": [
		39001,
		9,
		5997,
		5405,
		9001
	],
	"./blogs/polity/FiveYearPlans": [
		93093,
		9,
		5997,
		5405,
		3093
	],
	"./blogs/polity/FiveYearPlans.js": [
		93093,
		9,
		5997,
		5405,
		3093
	],
	"./blogs/polity/FundamentalDuty": [
		52061,
		9,
		5997,
		5405,
		2061
	],
	"./blogs/polity/FundamentalDuty.js": [
		52061,
		9,
		5997,
		5405,
		2061
	],
	"./blogs/polity/FundamentalRightsFlowchart": [
		7344,
		9,
		5997,
		5405,
		7344
	],
	"./blogs/polity/FundamentalRightsFlowchart.js": [
		7344,
		9,
		5997,
		5405,
		7344
	],
	"./blogs/polity/MakingConstitution": [
		90342,
		9,
		5997,
		5405,
		342
	],
	"./blogs/polity/MakingConstitution.js": [
		90342,
		9,
		5997,
		5405,
		342
	],
	"./blogs/polity/PMCouncilGovernorFlow": [
		81042,
		9,
		5997,
		5405,
		1042
	],
	"./blogs/polity/PMCouncilGovernorFlow.js": [
		81042,
		9,
		5997,
		5405,
		1042
	],
	"./blogs/polity/PanchayatFlow": [
		31325,
		9,
		5997,
		5405,
		1325
	],
	"./blogs/polity/PanchayatFlow.js": [
		31325,
		9,
		5997,
		5405,
		1325
	],
	"./blogs/polity/Parliament&StateFlow": [
		42176,
		9,
		5997,
		5405,
		2176
	],
	"./blogs/polity/Parliament&StateFlow.js": [
		42176,
		9,
		5997,
		5405,
		2176
	],
	"./blogs/polity/ParliamentPartTwoFlow": [
		32258,
		9,
		5997,
		5405,
		2258
	],
	"./blogs/polity/ParliamentPartTwoFlow.js": [
		32258,
		9,
		5997,
		5405,
		2258
	],
	"./blogs/polity/PolityMindMap": [
		80415,
		9,
		415
	],
	"./blogs/polity/PolityMindMap.js": [
		80415,
		9,
		415
	],
	"./blogs/polity/PreamblePartOne": [
		99573,
		9,
		5997,
		5405,
		9573
	],
	"./blogs/polity/PreamblePartOne.js": [
		99573,
		9,
		5997,
		5405,
		9573
	],
	"./blogs/polity/PresidentFlow": [
		3526,
		9,
		5997,
		5405,
		3526
	],
	"./blogs/polity/PresidentFlow.js": [
		3526,
		9,
		5997,
		5405,
		3526
	],
	"./blogs/polity/SourceConstitution": [
		38530,
		9,
		5997,
		5405,
		8530
	],
	"./blogs/polity/SourceConstitution.js": [
		38530,
		9,
		5997,
		5405,
		8530
	],
	"./blogs/polity/StateExecutiveFlow": [
		90585,
		9,
		5997,
		5405,
		585
	],
	"./blogs/polity/StateExecutiveFlow.js": [
		90585,
		9,
		5997,
		5405,
		585
	],
	"./blogs/polity/StenoPolity2025": [
		5569,
		9,
		5997,
		5405,
		5569
	],
	"./blogs/polity/StenoPolity2025.js": [
		5569,
		9,
		5997,
		5405,
		5569
	],
	"./blogs/polity/SupremeCourtFlow": [
		35578,
		9,
		5997,
		5405,
		5578
	],
	"./blogs/polity/SupremeCourtFlow.js": [
		35578,
		9,
		5997,
		5405,
		5578
	],
	"./blogs/static-gk/Arts-Personality-SSC": [
		34753,
		9,
		4753
	],
	"./blogs/static-gk/Arts-Personality-SSC.js": [
		34753,
		9,
		4753
	],
	"./blogs/static-gk/BioMTS2026": [
		10978,
		9,
		5997,
		5405,
		978
	],
	"./blogs/static-gk/BioMTS2026.js": [
		10978,
		9,
		5997,
		5405,
		978
	],
	"./blogs/static-gk/Book-Authors": [
		77980,
		9,
		7980
	],
	"./blogs/static-gk/Book-Authors.js": [
		77980,
		9,
		7980
	],
	"./blogs/static-gk/CA-Steno-2025": [
		5394,
		9,
		5997,
		5405,
		5394
	],
	"./blogs/static-gk/CA-Steno-2025.js": [
		5394,
		9,
		5997,
		5405,
		5394
	],
	"./blogs/static-gk/Classical-Dance": [
		77337,
		9,
		5997,
		5405,
		7337
	],
	"./blogs/static-gk/Classical-Dance.js": [
		77337,
		9,
		5997,
		5405,
		7337
	],
	"./blogs/static-gk/Dance-List-RRB-Others": [
		29297,
		9,
		9297
	],
	"./blogs/static-gk/Dance-List-RRB-Others.js": [
		29297,
		9,
		9297
	],
	"./blogs/static-gk/Dance-List-SSC": [
		77872,
		9,
		7872
	],
	"./blogs/static-gk/Dance-List-SSC.js": [
		77872,
		9,
		7872
	],
	"./blogs/static-gk/Folk-Dance": [
		1032,
		9,
		5997,
		5405,
		1032
	],
	"./blogs/static-gk/Folk-Dance.js": [
		1032,
		9,
		5997,
		5405,
		1032
	],
	"./blogs/static-gk/FolkDance": [
		9279,
		9,
		9279
	],
	"./blogs/static-gk/FolkDance.js": [
		9279,
		9,
		9279
	],
	"./blogs/static-gk/Founders": [
		38464,
		9,
		5997,
		5405,
		8464
	],
	"./blogs/static-gk/Founders.js": [
		38464,
		9,
		5997,
		5405,
		8464
	],
	"./blogs/static-gk/Geography-Flashcards": [
		320,
		9,
		320
	],
	"./blogs/static-gk/Geography-Flashcards.js": [
		320,
		9,
		320
	],
	"./blogs/static-gk/Gharana-Flowchart": [
		14765,
		9,
		5997,
		5405,
		4765
	],
	"./blogs/static-gk/Gharana-Flowchart.js": [
		14765,
		9,
		5997,
		5405,
		4765
	],
	"./blogs/static-gk/Govt-Schemes": [
		3861,
		9,
		5997,
		5405,
		3861
	],
	"./blogs/static-gk/Govt-Schemes.js": [
		3861,
		9,
		5997,
		5405,
		3861
	],
	"./blogs/static-gk/History-flashcards": [
		65174,
		9,
		5174
	],
	"./blogs/static-gk/History-flashcards.js": [
		65174,
		9,
		5174
	],
	"./blogs/static-gk/Important-Dates": [
		2976,
		9,
		5997,
		5405,
		2976
	],
	"./blogs/static-gk/Important-Dates.js": [
		2976,
		9,
		5997,
		5405,
		2976
	],
	"./blogs/static-gk/Indian-Census": [
		14959,
		9,
		5997,
		5405,
		4959
	],
	"./blogs/static-gk/Indian-Census.js": [
		14959,
		9,
		5997,
		5405,
		4959
	],
	"./blogs/static-gk/Indian-Festivals": [
		80799,
		9,
		5997,
		5405,
		799
	],
	"./blogs/static-gk/Indian-Festivals.js": [
		80799,
		9,
		5997,
		5405,
		799
	],
	"./blogs/static-gk/IndianCurrency": [
		76464,
		9,
		5997,
		5405,
		6464
	],
	"./blogs/static-gk/IndianCurrency.js": [
		76464,
		9,
		5997,
		5405,
		6464
	],
	"./blogs/static-gk/International-Organisations": [
		26696,
		9,
		5997,
		5405,
		6696
	],
	"./blogs/static-gk/International-Organisations.js": [
		26696,
		9,
		5997,
		5405,
		6696
	],
	"./blogs/static-gk/Musical-Instrument": [
		34588,
		9,
		5997,
		5405,
		4588
	],
	"./blogs/static-gk/Musical-Instrument.js": [
		34588,
		9,
		5997,
		5405,
		4588
	],
	"./blogs/static-gk/Olympic-Games": [
		52639,
		9,
		5997,
		5405,
		2639
	],
	"./blogs/static-gk/Olympic-Games.js": [
		52639,
		9,
		5997,
		5405,
		2639
	],
	"./blogs/static-gk/One-Liners": [
		88389,
		9,
		8389
	],
	"./blogs/static-gk/One-Liners.js": [
		88389,
		9,
		8389
	],
	"./blogs/static-gk/ParmarSirNotes": [
		89002,
		9,
		9002
	],
	"./blogs/static-gk/ParmarSirNotes.js": [
		89002,
		9,
		9002
	],
	"./blogs/static-gk/Polity-Flashcards": [
		8107,
		9,
		8107
	],
	"./blogs/static-gk/Polity-Flashcards.js": [
		8107,
		9,
		8107
	],
	"./blogs/static-gk/Space-Missions": [
		75694,
		9,
		5997,
		5405,
		5694
	],
	"./blogs/static-gk/Space-Missions.js": [
		75694,
		9,
		5997,
		5405,
		5694
	],
	"./blogs/static-gk/Sports-Dimensions": [
		46237,
		9,
		5997,
		5405,
		6237
	],
	"./blogs/static-gk/Sports-Dimensions.js": [
		46237,
		9,
		5997,
		5405,
		6237
	],
	"./blogs/static-gk/SportsTerms": [
		79908,
		9,
		9908
	],
	"./blogs/static-gk/SportsTerms.js": [
		79908,
		9,
		9908
	],
	"./blogs/static-gk/Static-Flashcards": [
		5874,
		9,
		5874
	],
	"./blogs/static-gk/Static-Flashcards.js": [
		5874,
		9,
		5874
	],
	"./blogs/static-gk/Steno-25-gk": [
		98364,
		9,
		5997,
		5405,
		8364
	],
	"./blogs/static-gk/Steno-25-gk.js": [
		98364,
		9,
		5997,
		5405,
		8364
	],
	"./blogs/static-gk/TemplesIndia": [
		58249,
		9,
		5997,
		5405,
		8249
	],
	"./blogs/static-gk/TemplesIndia.js": [
		58249,
		9,
		5997,
		5405,
		8249
	],
	"./blogs/static-gk/delhi-police-23-pyq1": [
		32985,
		9,
		5997,
		5405,
		2985
	],
	"./blogs/static-gk/delhi-police-23-pyq1.js": [
		32985,
		9,
		5997,
		5405,
		2985
	],
	"./blogs/static-gk/ssc-chsl-18nov": [
		54339,
		9,
		5997,
		5405,
		4339
	],
	"./blogs/static-gk/ssc-chsl-18nov.js": [
		54339,
		9,
		5997,
		5405,
		4339
	],
	"./components/card/Card": [
		21120,
		9
	],
	"./components/card/Card.css": [
		6445,
		9
	],
	"./components/card/Card.jsx": [
		21120,
		9
	],
	"./components/contact/Contact": [
		2397,
		9
	],
	"./components/contact/Contact.css": [
		26595,
		9
	],
	"./components/contact/Contact.jsx": [
		2397,
		9
	],
	"./components/experience/Experience": [
		61488,
		9
	],
	"./components/experience/Experience.css": [
		42769,
		9
	],
	"./components/experience/Experience.jsx": [
		61488,
		9
	],
	"./components/explore/ExploreSection": [
		86531,
		9
	],
	"./components/explore/ExploreSection.css": [
		71554,
		9
	],
	"./components/explore/ExploreSection.js": [
		86531,
		9
	],
	"./components/floatingDiv/FloatingDiv": [
		61206,
		9
	],
	"./components/floatingDiv/FloatingDiv.css": [
		2679,
		9
	],
	"./components/floatingDiv/FloatingDiv.jsx": [
		61206,
		9
	],
	"./components/footer/Footer": [
		65782,
		9
	],
	"./components/footer/Footer.css": [
		7775,
		9
	],
	"./components/footer/Footer.jsx": [
		65782,
		9
	],
	"./components/infoCard/InfoCard": [
		48880,
		9
	],
	"./components/infoCard/InfoCard.js": [
		48880,
		9
	],
	"./components/intro/Intro": [
		4510,
		9
	],
	"./components/intro/Intro.css": [
		12255,
		9
	],
	"./components/intro/Intro.jsx": [
		4510,
		9
	],
	"./components/navbar/Navbar": [
		92480,
		9
	],
	"./components/navbar/Navbar.css": [
		9645,
		9
	],
	"./components/navbar/Navbar.jsx": [
		92480,
		9
	],
	"./components/pdfViewer/PdfViewer": [
		41858,
		9,
		1858
	],
	"./components/pdfViewer/PdfViewer.js": [
		41858,
		9,
		1858
	],
	"./components/portfolio/Portfolio": [
		1414,
		9
	],
	"./components/portfolio/Portfolio.css": [
		2311,
		9
	],
	"./components/portfolio/Portfolio.jsx": [
		1414,
		9
	],
	"./components/previewCard/PreviewCard": [
		14978,
		9
	],
	"./components/previewCard/PreviewCard.js": [
		14978,
		9
	],
	"./components/services/Resume.pdf": [
		15043,
		1
	],
	"./components/services/Services": [
		73136,
		9
	],
	"./components/services/Services.css": [
		33457,
		9
	],
	"./components/services/Services.jsx": [
		73136,
		9
	],
	"./components/slider/SliderSection": [
		76903,
		9
	],
	"./components/slider/SliderSection.js": [
		76903,
		9
	],
	"./components/store/EbookCheckout": [
		45857,
		9
	],
	"./components/store/EbookCheckout.js": [
		45857,
		9
	],
	"./components/store/EbookDetails": [
		30103,
		9
	],
	"./components/store/EbookDetails.js": [
		30103,
		9
	],
	"./components/store/EbookImage": [
		4276,
		9,
		4276
	],
	"./components/store/EbookImage.js": [
		4276,
		9,
		4276
	],
	"./components/store/EbookStore": [
		38840,
		9
	],
	"./components/store/EbookStore.js": [
		38840,
		9
	],
	"./components/store/Ecart": [
		49522,
		9
	],
	"./components/store/Ecart.js": [
		49522,
		9
	],
	"./components/store/FeedbackModal": [
		56559,
		9
	],
	"./components/store/FeedbackModal.js": [
		56559,
		9
	],
	"./components/store/MyDownloads": [
		2096,
		9
	],
	"./components/store/MyDownloads.js": [
		2096,
		9
	],
	"./components/store/cart": [
		59337,
		9
	],
	"./components/store/cart.js": [
		59337,
		9
	],
	"./components/store/checkout": [
		21339,
		9
	],
	"./components/store/checkout.js": [
		21339,
		9
	],
	"./components/store/store": [
		5810,
		9
	],
	"./components/store/store.js": [
		5810,
		9
	],
	"./components/testimonial/Testimonial": [
		55884,
		9
	],
	"./components/testimonial/Testimonial.css": [
		33395,
		9
	],
	"./components/testimonial/Testimonial.jsx": [
		55884,
		9
	],
	"./components/timeline/MermaidTimeline": [
		45405,
		9,
		5997,
		5405
	],
	"./components/timeline/MermaidTimeline.js": [
		45405,
		9,
		5997,
		5405
	],
	"./components/toggle/Toggle": [
		21211,
		9
	],
	"./components/toggle/Toggle.css": [
		57893,
		9
	],
	"./components/toggle/Toggle.jsx": [
		21211,
		9
	],
	"./components/whatsappBtn/Donation": [
		70776,
		9
	],
	"./components/whatsappBtn/Donation.css": [
		25471,
		9
	],
	"./components/whatsappBtn/Donation.js": [
		70776,
		9
	],
	"./components/whatsappBtn/whatsappfix": [
		16705,
		9
	],
	"./components/whatsappBtn/whatsappfix.js": [
		16705,
		9
	],
	"./components/work/Work": [
		20638,
		9,
		638,
		7000
	],
	"./components/work/Work.css": [
		21507,
		9,
		1507
	],
	"./components/work/Work.jsx": [
		20638,
		9,
		638,
		7000
	],
	"./data/affairs": [
		13880,
		3
	],
	"./data/affairs.json": [
		13880,
		3
	],
	"./data/allData": [
		81050,
		9
	],
	"./data/allData.js": [
		81050,
		9
	],
	"./data/biology": [
		60257,
		3
	],
	"./data/biology.json": [
		60257,
		3
	],
	"./data/blogs": [
		77771,
		3
	],
	"./data/blogs.json": [
		77771,
		3
	],
	"./data/chemistry": [
		10240,
		3
	],
	"./data/chemistry.json": [
		10240,
		3
	],
	"./data/current": [
		41891,
		3,
		1891
	],
	"./data/current.json": [
		41891,
		3,
		1891
	],
	"./data/dummy": [
		95430,
		3,
		5430
	],
	"./data/dummy.json": [
		95430,
		3,
		5430
	],
	"./data/economics": [
		55340,
		3
	],
	"./data/economics.json": [
		55340,
		3
	],
	"./data/english": [
		58022,
		3
	],
	"./data/english.json": [
		58022,
		3
	],
	"./data/explore-more": [
		5645,
		3
	],
	"./data/explore-more.json": [
		5645,
		3
	],
	"./data/geography": [
		28616,
		3
	],
	"./data/geography.json": [
		28616,
		3
	],
	"./data/history": [
		9526,
		3
	],
	"./data/history.json": [
		9526,
		3
	],
	"./data/physics": [
		73539,
		3
	],
	"./data/physics.json": [
		73539,
		3
	],
	"./data/polity": [
		49963,
		3
	],
	"./data/polity.json": [
		49963,
		3
	],
	"./data/staticgk": [
		52062,
		3
	],
	"./data/staticgk.json": [
		52062,
		3
	],
	"./data/talksprint": [
		42568,
		3,
		2568
	],
	"./data/talksprint.json": [
		42568,
		3,
		2568
	],
	"./firebase/AuthListener": [
		96740,
		9
	],
	"./firebase/AuthListener.js": [
		96740,
		9
	],
	"./firebase/firebaseConfig": [
		91008,
		9
	],
	"./firebase/firebaseConfig.js": [
		91008,
		9
	],
	"./firebase/firestoreFunctions": [
		96052,
		9
	],
	"./firebase/firestoreFunctions.js": [
		96052,
		9
	],
	"./fonts/Gumela Regular.otf": [
		23937,
		1,
		3937
	],
	"./img/Assidus.png": [
		726,
		1
	],
	"./img/Facebook.png": [
		14216,
		1,
		4216
	],
	"./img/Shopify.png": [
		25632,
		1,
		5632
	],
	"./img/SwiperList.png": [
		78004,
		1
	],
	"./img/Upwork.png": [
		38092,
		1,
		8092
	],
	"./img/Vector1.png": [
		90472,
		1
	],
	"./img/Vector2.png": [
		27331,
		1
	],
	"./img/amazon.png": [
		83020,
		1,
		3020
	],
	"./img/arcadeHouse.png": [
		92102,
		1
	],
	"./img/boy.png": [
		21852,
		1
	],
	"./img/compass.png": [
		60838,
		1
	],
	"./img/crown.png": [
		28139,
		1
	],
	"./img/ecommerce.png": [
		53026,
		1,
		3026
	],
	"./img/fiverr.png": [
		28724,
		1,
		8724
	],
	"./img/github.png": [
		32061,
		1
	],
	"./img/glasses.png": [
		37866,
		1
	],
	"./img/glassesimoji.png": [
		73154,
		1
	],
	"./img/heartemoji.png": [
		80190,
		1
	],
	"./img/hoc.png": [
		60968,
		1,
		968
	],
	"./img/humble.png": [
		78145,
		1
	],
	"./img/instagram.png": [
		46978,
		1
	],
	"./img/linkedin.png": [
		90134,
		1
	],
	"./img/musicapp.png": [
		84742,
		1,
		4742
	],
	"./img/profile1.jpg": [
		62560,
		1,
		2560
	],
	"./img/profile2.jpg": [
		76175,
		1,
		6175
	],
	"./img/profile3.jpg": [
		3794,
		1,
		3794
	],
	"./img/profile4.jpg": [
		29281,
		1,
		9281
	],
	"./img/profile5.jpg": [
		51236,
		1,
		1236
	],
	"./img/profile6.jpg": [
		45395,
		1,
		5395
	],
	"./img/purpleblur.png": [
		27925,
		1,
		7925
	],
	"./img/sidebar.png": [
		90718,
		1,
		718
	],
	"./img/telegramPath.jpg": [
		49064,
		1,
		9064
	],
	"./img/thumbup.png": [
		26833,
		1
	],
	"./img/wave.png": [
		51671,
		1
	],
	"./index": [
		72812,
		9
	],
	"./index.js": [
		72812,
		9
	],
	"./pages/AboutUsPage": [
		76137,
		9
	],
	"./pages/AboutUsPage.js": [
		76137,
		9
	],
	"./pages/AdminReferralPanel": [
		17219,
		9
	],
	"./pages/AdminReferralPanel.js": [
		17219,
		9
	],
	"./pages/Authentication/AuthPage.css": [
		97954,
		9
	],
	"./pages/Authentication/Login": [
		2365,
		9
	],
	"./pages/Authentication/Login.js": [
		2365,
		9
	],
	"./pages/Authentication/LoginPromptModal": [
		5354,
		9,
		5354
	],
	"./pages/Authentication/LoginPromptModal.js": [
		5354,
		9,
		5354
	],
	"./pages/Authentication/Signup": [
		61562,
		9
	],
	"./pages/Authentication/Signup.js": [
		61562,
		9
	],
	"./pages/BlogsPage": [
		19013,
		9
	],
	"./pages/BlogsPage.js": [
		19013,
		9
	],
	"./pages/CancellationRefundPolicy": [
		31836,
		9
	],
	"./pages/CancellationRefundPolicy.js": [
		31836,
		9
	],
	"./pages/ContactUs": [
		98035,
		9
	],
	"./pages/ContactUs.js": [
		98035,
		9
	],
	"./pages/QuizPage": [
		5649,
		9
	],
	"./pages/QuizPage.js": [
		5649,
		9
	],
	"./pages/SubscriptionPage": [
		95945,
		9
	],
	"./pages/SubscriptionPage.js": [
		95945,
		9
	],
	"./pages/SummarizePage": [
		63273,
		9,
		3273
	],
	"./pages/SummarizePage.js": [
		63273,
		9,
		3273
	],
	"./pages/Terms&Conditions": [
		8934,
		9
	],
	"./pages/Terms&Conditions.js": [
		8934,
		9
	],
	"./pages/homepage/HomePage": [
		76726,
		9
	],
	"./pages/homepage/HomePage.css": [
		2181,
		9
	],
	"./pages/homepage/HomePage.js": [
		76726,
		9
	],
	"./utilities/Accordion": [
		80097,
		9,
		97
	],
	"./utilities/Accordion.js": [
		80097,
		9,
		97
	],
	"./utilities/ExplanationPopup": [
		78484,
		9
	],
	"./utilities/ExplanationPopup.js": [
		78484,
		9
	],
	"./utilities/FocusModePopup": [
		63756,
		9
	],
	"./utilities/FocusModePopup.js": [
		63756,
		9
	],
	"./utilities/GoogleTranslate": [
		6944,
		9,
		6944
	],
	"./utilities/GoogleTranslate.js": [
		6944,
		9,
		6944
	],
	"./utilities/LoginPromptAuth": [
		93074,
		9,
		3074
	],
	"./utilities/LoginPromptAuth.js": [
		93074,
		9,
		3074
	],
	"./utilities/MathPower": [
		55392,
		9
	],
	"./utilities/MathPower.js": [
		55392,
		9
	],
	"./utilities/SEO/ConstitutionalProvisionsSEO": [
		67386,
		9,
		7386
	],
	"./utilities/SEO/ConstitutionalProvisionsSEO.js": [
		67386,
		9,
		7386
	],
	"./utilities/SEO/ParmarDocumentsSEO": [
		99311,
		9,
		9311
	],
	"./utilities/SEO/ParmarDocumentsSEO.js": [
		99311,
		9,
		9311
	],
	"./utilities/SEO/QuizCategorySEO": [
		66387,
		9
	],
	"./utilities/SEO/QuizCategorySEO.js": [
		66387,
		9
	],
	"./utilities/SaveQuizAttempt": [
		26186,
		9
	],
	"./utilities/SaveQuizAttempt.js": [
		26186,
		9
	],
	"./utilities/SharePopup": [
		35852,
		9
	],
	"./utilities/SharePopup.js": [
		35852,
		9
	],
	"./utilities/SharePopupWithVideo": [
		56741,
		9
	],
	"./utilities/SharePopupWithVideo.js": [
		56741,
		9
	],
	"./utilities/Subfooter": [
		45882,
		9
	],
	"./utilities/Subfooter.js": [
		45882,
		9
	],
	"./utilities/SubscriptionContext": [
		17331,
		9
	],
	"./utilities/SubscriptionContext.js": [
		17331,
		9
	],
	"./utilities/createOrder": [
		63895,
		7,
		3895
	],
	"./utilities/createOrder.js": [
		63895,
		7,
		3895
	],
	"./utilities/emojiPopup": [
		72267,
		7,
		4648
	],
	"./utilities/emojiPopup.js": [
		72267,
		7,
		4648
	],
	"./utilities/flowchartImages": [
		30945,
		9,
		945
	],
	"./utilities/flowchartImages.js": [
		30945,
		9,
		945
	],
	"./utilities/googelAd": [
		30443,
		9,
		443
	],
	"./utilities/googelAd.js": [
		30443,
		9,
		443
	],
	"./utilities/huggingFaceApi": [
		94341,
		9,
		4341
	],
	"./utilities/huggingFaceApi.js": [
		94341,
		9,
		4341
	],
	"./utilities/referralUtils": [
		53449,
		7,
		3449
	],
	"./utilities/referralUtils.js": [
		53449,
		7,
		3449
	],
	"./utilities/scrollToTop": [
		77076,
		9
	],
	"./utilities/scrollToTop.js": [
		77076,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;